"use client"

import { PanelBottom } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelBottomIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelBottomIcon = component(Icon)({ as: PanelBottom })
